export default (href) => {
    if (!href || href == "") return undefined;
    const link = href.trim();
    if (link.startsWith('http')) return link
    if (link.startsWith('/') && !link.startsWith('/preprod-preview')) return `${window.location.href.toString().replace(window.location.hash, '')}#${link}`
}
